module.exports = __webpack_public_path__ + "static/media/raport_activitate_2024.bd253deb.pdf";